import { UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-employee-benefit-sign-footer',
  templateUrl: 'benefit-sign-footer.component.html',
  styleUrls: ['./benefit-sign-footer.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, TranslateModule, UpperCasePipe, MatButtonModule, FlexLayoutModule],
})
export class EmployeeBenefitSignFooterComponent {
  @Output() public readonly cancelSelection = new EventEmitter<void>();
  @Output() public readonly send = new EventEmitter<void>();
  @Input() public sendDisabled = false;

  isConfirmed = false;

  confirm() {
    this.isConfirmed = true;
    this.send.emit();
  }
}
